import '../static/RichText.css';
import React__default, { forwardRef } from "react";
import clsx from "clsx";
import { sanitize } from "isomorphic-dompurify";
import { u as useTagName } from "./useTagName.COq0HFfN.mjs";
const richText = `_richText_e969a4a`;
const highlight = `_highlight_176fb60`;
const highlightLinks = `_highlightLinks_8ec8e8d`;
const gradientBoldText = `_gradientBoldText_4785701`;
const styles = { richText, highlight, highlightLinks, gradientBoldText };
const RichTextInner = ({
  as,
  children,
  className,
  gradientBoldText: gradientBoldText2,
  highlightLinks: highlightLinks2 = true,
  allowedTags = [],
  addTags = [],
  addAttrs = [],
  ...props
}, ref) => {
  const Component = useTagName(as);
  return /* @__PURE__ */ React__default.createElement(
    Component,
    {
      ...props,
      className: clsx(
        styles.richText,
        {
          [styles.highlightLinks]: highlightLinks2,
          [styles.gradientBoldText]: gradientBoldText2
        },
        className
      ),
      ...typeof children === "string" ? {
        dangerouslySetInnerHTML: {
          __html: sanitize(children, {
            ADD_TAGS: addTags,
            ALLOWED_TAGS: allowedTags,
            ...Array.isArray(allowedTags) && allowedTags.length === 0 && {
              USE_PROFILES: { html: true }
            },
            ADD_ATTR: ["target", ...addAttrs],
            ...as === "p" && {
              FORBID_TAGS: ["p"]
            }
          })
        }
      } : { children },
      ref
    }
  );
};
const RichText = forwardRef(RichTextInner);
export {
  RichTextInner as R,
  RichText as a
};
//# sourceMappingURL=RichText.Dek7-xX-.mjs.map
